import angular from 'angular';

/* @ngInject */
const objectLength = (/** @type {{}} */ object) => typeof object === 'object' && Object.keys(object).length > 0;

const objectLengthFilter = () => objectLength;

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:objLength
 * @function
 * @description
 * # objLength
 * Returns the length of the specified object.
 *
 * @example
 *   Usage:
 *   <p>{{ OBJECT | objLength }}</p>
 *
 *   <p>{{ {hello:"world",tree:3} | objLength }}</p> // returns <p>2</p>
 */
angular.module('app')
	.filter('objLength', objectLengthFilter);
